import axios from "axios";
import * as supportTicket from "../../types/admin/supportTypes";

export const createSupportTicketAction =
  (body, token, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: supportTicket.CREATE_SUPPORT_TICKET_REQUEST,
      });
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/support/create`,
        body,
        config
      );
      dispatch({
        type: supportTicket.CREATE_SUPPORT_TICKET_SUCCESS,
        payload: data?.data,
      });
      return data?.data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
            ? error.response.data.message
            : error.response.data.errors
              ? error.response.data.errors[0].msg
              : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: supportTicket.CREATE_SUPPORT_TICKET_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const getAllSupportTicketAction =
  (token, companyId) => async (dispatch, getState) => {
    // console.log({ todoId });
    try {
      dispatch({
        type: supportTicket.GET_ALL_SUPPORT_TICKET_REQUEST,
      });
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/support/user-ticket/get-all`,
        config
      );
      dispatch({
        type: supportTicket.GET_ALL_SUPPORT_TICKET_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
            ? error.response.data.message
            : error.response.data.errors
              ? error.response.data.errors[0].msg
              : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: supportTicket.GET_ALL_SUPPORT_TICKET_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const getSupportTicketByIdAction =
  (id, token, companyId) => async (dispatch, getState) => {
    // console.log({ todoId });
    try {
      dispatch({
        type: supportTicket.GET_SUPPORT_TICKET_BY_ID_REQUEST,
      });
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/support/get/${id}`,
        config
      );
      dispatch({
        type: supportTicket.GET_SUPPORT_TICKET_BY_ID_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
            ? error.response.data.message
            : error.response.data.errors
              ? error.response.data.errors[0].msg
              : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: supportTicket.GET_SUPPORT_TICKET_BY_ID_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const updateSupportTicketAction =
  (body, id, token, companyId) => async (dispatch, getState) => {
    // console.log({ todoId });
    try {
      dispatch({
        type: supportTicket.GET_ALL_SUPPORT_TICKET_REQUEST,
      });
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      };
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/support/update/${id}`,
        body,
        config
      );
      dispatch({
        type: supportTicket.CREATE_SUPPORT_MESSAGE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
            ? error.response.data.message
            : error.response.data.errors
              ? error.response.data.errors[0].msg
              : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: supportTicket.CREATE_SUPPORT_MESSAGE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const createSupportMessageAction =
  (body, token, companyId) => async (dispatch, getState) => {
    // console.log({ todoId });
    try {
      dispatch({
        type: supportTicket.CREATE_SUPPORT_MESSAGE_REQUEST,
      });
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/support-messages/msg-create`,
        body,
        config
      );
      dispatch({
        type: supportTicket.CREATE_SUPPORT_MESSAGE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
            ? error.response.data.message
            : error.response.data.errors
              ? error.response.data.errors[0].msg
              : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: supportTicket.CREATE_SUPPORT_MESSAGE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const getSupportMesaageByTicketIdAction =
  (id, token, companyId) => async (dispatch, getState) => {
    // console.log({ todoId });
    try {
      dispatch({
        type: supportTicket.GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_REQUEST,
      });
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/support-messages/get-all/${id}`,
        config
      );
      dispatch({
        type: supportTicket.GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
            ? error.response.data.message
            : error.response.data.errors
              ? error.response.data.errors[0].msg
              : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: supportTicket.GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
export const getAllCompanySupportTicketAction =
  (query = {}, token) =>
    async (dispatch, getState) => {
      try {
        dispatch({
          type: supportTicket.GET_ALL_COMPANY_SUPPORT_TICKET_REQUEST,
        });

        const {
          sharedLogin: { sharedUserInfo },
          tokenInfoList,
        } = getState();

        /**
         * IMPORTANT: Admin routes authenticate via sharedUserInfo.payload.token.
         * tokenInfoList may hold a user/widget token (e.g. from the support chat
         * screen) which is NOT valid for admin API endpoints.
         * Always prefer sharedUserInfo token for admin calls.
         */
        const resolvedToken =
          sharedUserInfo?.payload?.token ||
          token ||
          tokenInfoList?.info?.token;

        // Resolve companyId — prefer explicitly passed value
        let resolvedCompanyId = null;

        if (!resolvedCompanyId) {
          if (sharedUserInfo?.payload?.company) {
            resolvedCompanyId = sharedUserInfo?.payload?.company?._id;
          } else if (sharedUserInfo?.empCompanies && sharedUserInfo?.empCompanies?.length > 0) {
            resolvedCompanyId =
              sharedUserInfo?.empCompanies[0]?.companyId?._id;
          }
        }

        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${resolvedToken}`,
          },
        };

        // Build query params
        const queryParams = new URLSearchParams();
        if (query.status) queryParams.append("status", query.status);
        if (query.search) queryParams.append("search", query.search);
        if (query.supportType)
          queryParams.append("supportType", query.supportType);
        if (query.fromDate) queryParams.append("fromDate", query.fromDate);
        if (query.toDate) queryParams.append("toDate", query.toDate);
        if (query.page) queryParams.append("page", query.page);

        const queryString = queryParams.toString();
        const url = `${process.env.REACT_APP_BACKEND_URI}/api/admin/${resolvedCompanyId}/support/company-wise/get-all${queryString ? `?${queryString}` : ""}`;

        const { data } = await axios.get(url, config);

        // ✅ STORE IN REDUX
        const payload = data?.data;

        dispatch({
          type: supportTicket.GET_ALL_COMPANY_SUPPORT_TICKET_SUCCESS,
          payload: payload,
        });

        // ✅ RETURN FOR COMPONENT USAGE
        return payload;
      } catch (error) {
        let err =
          error.response &&
          (typeof error.response.data === "string"
            ? error.response.data
            : error.response.data.message
              ? error.response.data.message
              : error.response.data.errors
                ? error.response.data.errors[0].msg
                : error.message);

        if (!err) {
          err = "Network Error";
        }

        dispatch({
          type: supportTicket.GET_ALL_COMPANY_SUPPORT_TICKET_FAIL,
          payload: err,
        });

        throw Error(err);
      }
    };

// ==========================================
// ADMIN SUPPORT DETAIL ACTIONS (Widget Decoupled)
// ==========================================

export const adminGetSupportTicketByIdAction =
  (id, token, companyId, hasAuth) => async (dispatch, getState) => {
    try {
      dispatch({
        type: supportTicket.ADMIN_GET_SUPPORT_TICKET_BY_ID_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      let tokens = token;
      let company = companyId;
      let companyIdFinal;
      if (sharedUserInfo?.payload?.company) {
        companyIdFinal = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies && sharedUserInfo?.empCompanies.length > 0) {
        companyIdFinal = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      if (hasAuth) {
        tokens = sharedUserInfo?.payload?.token;
        company = companyIdFinal;
      }

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${tokens}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${company}/support/get/${id}`,
        config,
      );
      dispatch({
        type: supportTicket.ADMIN_GET_SUPPORT_TICKET_BY_ID_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
            ? error.response.data.message
            : error.response.data.errors
              ? error.response.data.errors[0].msg
              : error.message);
      if (!err) {
        err = "Network Error";
      }
      dispatch({
        type: supportTicket.ADMIN_GET_SUPPORT_TICKET_BY_ID_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const adminGetSupportMessageByTicketIdAction =
  (id, token, companyId, hasAuth) => async (dispatch, getState) => {
    try {
      dispatch({
        type: supportTicket.ADMIN_GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_REQUEST,
      });

      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      let tokens = token;
      let company = companyId;
      let companyIdFinal;
      if (sharedUserInfo?.payload?.company) {
        companyIdFinal = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies && sharedUserInfo?.empCompanies.length > 0) {
        companyIdFinal = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      if (hasAuth) {
        tokens = sharedUserInfo?.payload?.token;
        company = companyIdFinal;
      }

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${tokens}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${company}/support-messages/get-all/${id}`,
        config,
      );
      dispatch({
        type: supportTicket.ADMIN_GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
            ? error.response.data.message
            : error.response.data.errors
              ? error.response.data.errors[0].msg
              : error.message);
      if (!err) {
        err = "Network Error";
      }
      dispatch({
        type: supportTicket.ADMIN_GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const adminCreateSupportMessageAction =
  (body, token, companyId, hasAuth, files = []) =>
    async (dispatch, getState) => {
      try {
        dispatch({
          type: supportTicket.ADMIN_CREATE_SUPPORT_MESSAGE_REQUEST,
        });
        const {
          sharedLogin: { sharedUserInfo },
        } = getState();

        let tokens = token;
        let company = companyId;
        let companyIdFinal;
        if (sharedUserInfo?.payload?.company) {
          companyIdFinal = sharedUserInfo?.payload?.company?._id;
        } else if (sharedUserInfo?.empCompanies && sharedUserInfo?.empCompanies.length > 0) {
          companyIdFinal = sharedUserInfo?.empCompanies[0]?.companyId?._id;
        }
        if (hasAuth) {
          tokens = sharedUserInfo?.payload?.token;
          company = companyIdFinal;
        }

        let payload = body;
        const config = {
          headers: {
            Authorization: `${tokens}`,
          },
        };

        if (files && files.length > 0) {
          const formData = new FormData();
          formData.append("supportId", body.supportId);
          formData.append("body", body.body);
          formData.append("userModel", body.userModel);
          formData.append("maxAI", body.maxAI);

          files.forEach((f) => {
            formData.append("attachment", f);
          });
          payload = formData;
          config.headers["Content-Type"] = "multipart/form-data";
        } else {
          config.headers["Content-Type"] = "application/json";
        }

        const { data } = await axios.post(
          `${process.env.REACT_APP_BACKEND_URI}/api/admin/${company}/support-messages/msg-create`,
          payload,
          config,
        );
        dispatch({
          type: supportTicket.ADMIN_CREATE_SUPPORT_MESSAGE_SUCCESS,
          payload: data?.data,
        });
        return data?.data;
      } catch (error) {
        let err =
          error.response &&
          (typeof error.response.data === "string"
            ? error.response.data
            : error.response.data.message
              ? error.response.data.message
              : error.response.data.errors
                ? error.response.data.errors[0].msg
                : error.message);
        if (!err) {
          err = "Network Error";
        }
        dispatch({
          type: supportTicket.ADMIN_CREATE_SUPPORT_MESSAGE_FAIL,
          payload: err,
        });
        throw Error(err);
      }
    };

export const adminUpdateSupportTicketAction =
  (body, id, token, companyId, hasAuth) => async (dispatch, getState) => {
    try {
      dispatch({
        type: supportTicket.ADMIN_UPDATE_SUPPORT_TICKET_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      let tokens = token;
      let company = companyId;
      let companyIdFinal;
      if (sharedUserInfo?.payload?.company) {
        companyIdFinal = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies && sharedUserInfo?.empCompanies.length > 0) {
        companyIdFinal = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      if (hasAuth) {
        tokens = sharedUserInfo?.payload?.token;
        company = companyIdFinal;
      }

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${tokens}`,
        },
      };
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${company}/support/update/${id}`,
        body,
        config,
      );
      dispatch({
        type: supportTicket.ADMIN_UPDATE_SUPPORT_TICKET_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
            ? error.response.data.message
            : error.response.data.errors
              ? error.response.data.errors[0].msg
              : error.message);
      if (!err) {
        err = "Network Error";
      }
      dispatch({
        type: supportTicket.ADMIN_UPDATE_SUPPORT_TICKET_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
